<template>
    <div class="modal fade" id="confirmHideProduct" tabindex="-1" role="dialog" aria-labelledby="confirmHideProduct" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content campaign-g-addedit">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">{{heading}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click = "closeHideConfirmModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>Are you sure, you want to hide?</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click = "closeHideConfirmModal">No</button>
                    <button type="button" @click="hideSelectedProducts" class="btn btn-primary" data-dismiss="modal">Yes</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'ProductListHideConfirmModal',
    data() {
        return {

        }
    },
    props: {
        heading:{
            type: String,
            required: false,
            default:'Hide Product'
        }
    },
    methods: {
        hideSelectedProducts() {
            this.$emit('hideSelectedProducts')
        },
		closeHideConfirmModal(){
			this.$emit('closeHideConfirmModal')
		}
    },
}
</script>

<style lang="scss">

</style>
